import { useEffect, useState } from "react";

export const useFocusWithin = (
  ref,
  { keyboard = true, mouse = true, self = true } = {}
) => {
  const [isFocusWithin, setIsFocusWithin] = useState(null);

  useEffect(() => {
    const onClick = () => {
      if (ref && ref.current) {
        const currentFocused = self && ref.current === document.activeElement;
        setIsFocusWithin(
          currentFocused || ref.current.contains(document.activeElement)
        );
      }
    };

    const onTabPress = e => {
      if (ref && ref.current && e.key === "Tab") {
        const currentFocused = self && ref.current === document.activeElement;
        setIsFocusWithin(
          currentFocused || ref.current.contains(document.activeElement)
        );
      }
    };

    if (ref && ref.current) {
      if (mouse) {
        document.addEventListener("click", onClick);
      }
      if (keyboard) {
        document.addEventListener("keyup", onTabPress);
      }
    }

    return () => {
      if (mouse) {
        document.removeEventListener("click", onClick);
      }
      if (keyboard) {
        document.removeEventListener("keyup", onTabPress);
      }
    };
  }, [ref, mouse, keyboard]);

  return [isFocusWithin, setIsFocusWithin];
};
